export default "__VITE_ASSET__DWWBDHhF__"